import { useNavigate } from "react-router-dom";
import { flushSync } from "react-dom";

/**
 * Drop-in replacement for React Router's useNavigate.
 * Wraps all navigations in the View Transition API for smooth cross-page
 * animations. Falls back to plain navigation on unsupported browsers.
 *
 * Usage:  const navigate = useAppNavigate();
 *         navigate("/:tenantId/checkout")  // string path
 *         navigate(-1)                     // back
 */
export function useAppNavigate() {
  const navigate = useNavigate();

  return (to, options) => {
    if (!document.startViewTransition) {
      navigate(to, options);
      return;
    }

    if (typeof to === "number") {
      // Delta navigation (back/forward) — history pop is async, no flushSync
      document.startViewTransition(() => navigate(to, options));
    } else {
      // String/object path — force synchronous DOM update inside the transition
      // so the browser captures the new page state for the cross-fade
      document.startViewTransition(() =>
        flushSync(() => navigate(to, options))
      );
    }
  };
}
